package com.macrofocus.eflux.network

actual fun Double.toFixed(digits: Int): String = this.asDynamic().toFixed(digits)

private val regex1 = "[0]*$".toRegex()
private val regex2 = ".$".toRegex()
actual fun Double.format(digits: Int): String = regex2.replace(regex1.replace(this.asDynamic().toFixed(digits).toString(), ""), "")
actual fun Float.format(digits: Int): String = regex2.replace(regex1.replace(this.asDynamic().toFixed(digits).toString(), ""), "")